import React from 'react';
import DateFormatter from './DateFormatter';

const TransactionCard = ({data}) => {
const amountToDisplay = data.credit === 0 ? data.debit : data.credit;
const isCredit = data.credit === 0 ? false : true;

  return (
    <div className="w-full p-2 bg-gray-100">
      <div className="w-full bg-white rounded-md shadow-md p-4">
        <div className="flex items-center">
          <div className="flex items-center justify-center w-10 h-10 bg-gray-200 text-black text-xs font-medium rounded-full opacity-50 mr-3">
            PKR
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-gray-700 text-lg font-semibold truncate block sm:overflow-hidden max-w-full whitespace-nowrap">
              {data.user_description}
            </div>
            <div className="text-gray-400 text-xs mt-2">
              <DateFormatter date={data.created_at}/>
            </div>
          </div>
          <div className="flex items-center ml-2">
            <div className={`w-2.5 h-2.5 rounded-full mr-2 ${
                isCredit ? 'bg-green-500' : 'bg-red-500'
              }`} /> {/* Debit/Credit Indicator */}
            <div className="text-gray-700 text-lg font-semibold">
              PKR {amountToDisplay}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionCard;
